<template><!-- svgo-optimised -->
<svg class="icon icon__loading" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10v2C5.373 24 0 18.627 0 12S5.373 0 12 0z" fill-rule="evenodd" clip-rule="evenodd"/></svg>
</template>